<div class="card risks">
  <div class="card-header">{{ "lang_risks" | language }}</div>
  <div class="card-body pad0">
    <div class="mbrl15">
      <div class="row">
        <div class="col-sm-3 col-xs-12 mb-10">
          <select
            matTooltip="{{ 'lang_type' | language }}"
            [(ngModel)]="risk_type"
            (change)="getRisks()"
            class="form-control almnabrformcontrol"
          >
            <option value="">{{ "lang_all" | language }}</option>
            <option
              value="{{ item?.value }}"
              *ngFor="let item of risk_type_list"
            >
              {{ item?.label }}
            </option>
          </select>
        </div>
        <div class="col-sm-3 col-xs-12 mb-10">
          <select
            matTooltip="{{ 'lang_risk_continuity' | language }}"
            [(ngModel)]="risk_continuity"
            (change)="getRisks()"
            class="form-control almnabrformcontrol"
          >
            <option value="">{{ "lang_all" | language }}</option>
            <option
              value="{{ item?.value }}"
              *ngFor="let item of risk_continuity_list"
            >
              {{ item?.label }}
            </option>
          </select>
        </div>
        <div class="col-sm-3 col-xs-12 mb-10">
          <select
            matTooltip="{{ 'lang_status' | language }}"
            [(ngModel)]="risk_status"
            (change)="getRisks()"
            class="form-control almnabrformcontrol"
          >
            <option value="">{{ "lang_all" | language }}</option>
            <option
              value="{{ item?.value }}"
              *ngFor="let item of risk_status_list"
            >
              {{ item?.label }}
            </option>
          </select>
        </div>
        <div class="col-sm-3 col-xs-12 mb-10">
          <button
            id="btnSearch"
            type="button"
            mat-raised-button
            color="primary"
            class="add-btn"
            (click)="onAddUpdateRisk(createupdaterisk)"
          >
            <i class="fa fa-plus mr-2 ml-2 add-btn-icon"></i>
            <span class="add-btn-text">{{ "lang_add" | language }}</span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive dropdownyes customResponsive">
            <table border="1" class="table CustomTable">
              <thead>
                <tr>
                  <td>#</td>
                  <td>
                    {{ "lang_title" | language }}
                  </td>
                  <td>{{ "lang_type" | language }}</td>
                  <td>{{ "lang_risk_continuity" | language }}</td>
                  <td>{{ "lang_risk_owner" | language }}</td>
                  <td>{{ "lang_writer" | language }}</td>
                  <td>{{ "lang_ondate" | language }}</td>
                  <td>{{ "lang_status" | language }}</td>
                  <td>{{ "lang_action" | language }}</td>
                </tr>
              </thead>
              <tbody *ngIf="risk_list.length" class="AppendList">
                <tr
                  *ngFor="
                    let list of risk_list;
                    let i = index;
                    let odd = odd;
                    let even = even
                  "
                  [ngClass]="{ odd: odd, even: even }"
                >
                  <td>{{ i + 1 }}</td>
                  <td *ngIf="lang_key == 'en'">
                    {{ list.risk_description_en }}
                  </td>
                  <td *ngIf="lang_key == 'ar'">
                    {{ list.risk_description_ar }}
                  </td>
                  <td>{{ list.risk_type }}</td>
                  <td>{{ list.risk_continuity }}</td>
                  <td>{{ list.risk_owner }}</td>
                  <td>{{ list.risk_writer }}</td>
                  <td>{{ list.created_at }}</td>
                  <td>
                    <span
                      [ngClass]="{
                        badgesuccess: list.risk_status == 'open',
                        badgeorange: list.risk_status == 'cause_issue',
                        badgered: list.risk_status == 'close'
                      }"
                    >
                      {{ list.risk_status }}
                    </span>
                  </td>
                  <td>
                    <i
                      matTooltip="{{ 'lang_edit' | language }}"
                      (click)="onAddUpdateRisk(createupdaterisk, list)"
                      class="fa fa-pencil-square-o fa-icon mnabricon mr-2 ml-2"
                    ></i>
                    <i
                      matTooltip="{{ 'lang_delete' | language }}"
                      (click)="deleteRisk(list)"
                      class="fa fa-trash fa-icon red"
                    ></i>
                    <i
                      [matMenuTriggerFor]="menu"
                      matTooltip="{{ 'lang_change_status' | language }}"
                      class="fa fa-refresh fa-icon mnabricon mr-2 ml-2"
                    ></i>
                    <mat-menu #menu="matMenu">
                      <button
                        (click)="onChangeRiskStatus(list, 'open')"
                        mat-menu-item
                      >
                        <span>{{ "lang_open" | language }}</span>
                      </button>
                      <button
                        mat-menu-item
                        (click)="onChangeRiskStatus(list, 'close')"
                      >
                        <span>{{ "lang_close" | language }}</span>
                      </button>
                      <button
                        mat-menu-item
                        (click)="
                          onChangeRiskStatus(list, 'cause_issue', updateissue)
                        "
                      >
                        <span>{{ "lang_cause_issue" | language }}</span>
                      </button>
                    </mat-menu>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="!risk_list.length" class="AppendList">
                <tr class="odd">
                  <td colspan="10" align="center">
                    {{ "lang_no_data" | language }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="risk_list?.length" style="padding: 0 15px">
      <div class="row responsive_pagination">
        <div
          class="col-lg-3 col-sm-3 mb-10"
          style="height: fit-content; margin: auto 0"
        >
          {{ "lang_total" | language }} : {{ total_records }}
        </div>
        <div
          class="col-lg-5 col-sm-5 mb-10"
          style="display: flex; justify-content: center"
        >
          <ngb-pagination
            class="m-auto"
            [collectionSize]="total_records"
            [rotate]="true"
            [ellipses]="false"
            [maxSize]="3"
            [boundaryLinks]="true"
            [(page)]="risk_pageno"
            [pageSize]="risk_pagesize"
            (pageChange)="getRisks()"
          ></ngb-pagination>
        </div>
        <div
          class="col-lg-3 col-sm-3"
          style="display: flex; justify-content: end; margin: auto"
        >
          <mat-select
            [(ngModel)]="risk_pagesize"
            (selectionChange)="getRisks()"
          >
            <mat-option class="text-center" value="10"
              >10 {{ "lang_per_page" | language }}
            </mat-option>
            <mat-option class="text-center" value="20"
              >20 {{ "lang_per_page" | language }}
            </mat-option>
            <mat-option class="text-center" value="50"
              >50 {{ "lang_per_page" | language }}
            </mat-option>
            <mat-option class="text-center" value="100"
              >100 {{ "lang_per_page" | language }}</mat-option
            >
            <mat-option class="text-center" value="500"
              >500 {{ "lang_per_page" | language }}</mat-option
            >
          </mat-select>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #createupdaterisk>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="!isEdit">{{ "lang_add" | language }}</h4>
      <h4 class="modal-title" *ngIf="isEdit">{{ "lang_edit" | language }}</h4>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        (click)="modalRef.hide()"
      >
        &times;
      </button>
    </div>
    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="modal-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="risk_description_en">{{
                "lang_title_english" | language
              }}</label>
              <input
                type="text"
                class="form-control"
                id="risk_description_en"
                name="risk_description_en"
                formControlName="risk_description_en"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="risk_description_ar">{{
                "lang_title_arabic" | language
              }}</label>
              <input
                type="text"
                class="form-control"
                id="risk_description_ar"
                name="risk_description_ar"
                formControlName="risk_description_ar"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="type"
                >{{ "lang_type" | language }}:<span class="red">*</span></label
              >
              <select
                class="form-control almnabrformcontrol"
                formControlName="risk_type"
              >
                <option value="">{{ "lang_choose_options" | language }}</option>
                <option
                  value="{{ item?.value }}"
                  *ngFor="let item of risk_type_list"
                >
                  {{ item?.label }}
                </option>
              </select>
              <mat-error
                *ngIf="
                  form.controls['risk_type'].touched &&
                  form.controls['risk_type'].errors?.required
                "
              >
                {{ "lang_field_required" | language }}
              </mat-error>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="risk_continuity"
                >{{ "lang_risk_continuity" | language }}:<span class="red"
                  >*</span
                ></label
              >
              <select
                class="form-control almnabrformcontrol"
                formControlName="risk_continuity"
              >
                <option value="">{{ "lang_choose_options" | language }}</option>
                <option
                  value="{{ item?.value }}"
                  *ngFor="let item of risk_continuity_list"
                >
                  {{ item?.label }}
                </option>
              </select>
              <mat-error
                *ngIf="
                  form.controls['risk_continuity'].touched &&
                  form.controls['risk_continuity'].errors?.required
                "
              >
                {{ "lang_field_required" | language }}
              </mat-error>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="risk_status"
                >{{ "lang_status" | language }}:<span class="red"
                  >*</span
                ></label
              >
              <select
                class="form-control almnabrformcontrol"
                formControlName="risk_status"
              >
                <option value="">{{ "lang_choose_options" | language }}</option>
                <option
                  value="{{ item?.value }}"
                  *ngFor="let item of risk_status_list"
                >
                  {{ item?.label }}
                </option>
              </select>
              <mat-error
                *ngIf="
                  form.controls['risk_status'].touched &&
                  form.controls['risk_status'].errors?.required
                "
              >
                {{ "lang_field_required" | language }}
              </mat-error>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="risk_impact">{{
                "lang_risk_impact" | language
              }}</label>
              <input
                type="text"
                class="form-control"
                id="risk_impact"
                name="risk_impact"
                formControlName="risk_impact"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="risk_probability">{{
                "lang_risk_probability" | language
              }}</label>
              <input
                type="text"
                class="form-control"
                id="risk_probability"
                name="risk_probability"
                formControlName="risk_probability"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="risk_rank">{{ "lang_risk_rank" | language }}</label>
              <input
                type="text"
                class="form-control"
                id="risk_rank"
                name="risk_rank"
                formControlName="risk_rank"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="risk_impact_description">{{
                "lang_risk_impact_description" | language
              }}</label>
              <input
                type="text"
                class="form-control"
                id="risk_impact_description"
                name="risk_impact_description"
                formControlName="risk_impact_description"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="risk_mitigation_plan">{{
                "lang_risk_mitigation_plan" | language
              }}</label>
              <input
                type="text"
                class="form-control"
                id="risk_mitigation_plan"
                name="risk_mitigation_plan"
                formControlName="risk_mitigation_plan"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="risk_owner">{{ "lang_risk_owner" | language }}</label>
              <input
                type="text"
                class="form-control"
                id="risk_owner"
                name="risk_owner"
                formControlName="risk_owner"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="risk_mitigation_by">{{
                "lang_risk_mitigation_by" | language
              }}</label>
              <input
                type="text"
                class="form-control"
                id="risk_mitigation_by"
                name="risk_mitigation_by"
                formControlName="risk_mitigation_by"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer pad15">
        <div class="row">
          <div class="col-12 mb-10">
            <app-alert id="default-alert"></app-alert>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-xs-12 mb-10">
            <button
              type="button"
              class="btn btn-secondary secondarybutton"
              data-dismiss="modal"
              (click)="modalRef.hide()"
            >
              {{ "lang_close" | language }}
            </button>
          </div>
          <div class="col-md-6 col-xs-12 mb-10">
            <button type="submit" class="albutton">
              {{ "lang_submit" | language }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
<ng-template #updateissue>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ "lang_add_issue" | language }}</h4>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        (click)="modalRef.hide()"
      >
        &times;
      </button>
    </div>
    <form [formGroup]="form2" (ngSubmit)="add_issue()">
      <div class="modal-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="issue_description_en">{{
                "lang_title_english" | language
              }}</label>
              <input
                type="text"
                class="form-control"
                id="issue_description_en"
                name="issue_description_en"
                formControlName="issue_description_en"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="issue_description_ar">{{
                "lang_title_arabic" | language
              }}</label>
              <input
                type="text"
                class="form-control"
                id="issue_description_ar"
                name="issue_description_ar"
                formControlName="issue_description_ar"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="type"
                >{{ "lang_type" | language }}:<span class="red">*</span></label
              >
              <select
                class="form-control almnabrformcontrol"
                formControlName="issue_type"
              >
                <option value="">{{ "lang_choose_options" | language }}</option>
                <option
                  value="{{ item?.value }}"
                  *ngFor="let item of issue_type_list"
                >
                  {{ item?.label }}
                </option>
              </select>
              <mat-error
                *ngIf="
                  form2.controls['issue_type'].touched &&
                  form2.controls['issue_type'].errors?.required
                "
              >
                {{ "lang_field_required" | language }}
              </mat-error>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="issue_level"
                >{{ "lang_issue_level" | language }}:<span class="red"
                  >*</span
                ></label
              >
              <select
                class="form-control almnabrformcontrol"
                formControlName="issue_level"
              >
                <option value="">{{ "lang_choose_options" | language }}</option>
                <option
                  value="{{ item?.value }}"
                  *ngFor="let item of issue_level_list"
                >
                  {{ item?.label }}
                </option>
              </select>
              <mat-error
                *ngIf="
                  form2.controls['issue_level'].touched &&
                  form2.controls['issue_level'].errors?.required
                "
              >
                {{ "lang_field_required" | language }}
              </mat-error>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="issue_status"
                >{{ "lang_status" | language }}:<span class="red"
                  >*</span
                ></label
              >
              <select
                class="form-control almnabrformcontrol"
                formControlName="issue_status"
              >
                <option value="">{{ "lang_choose_options" | language }}</option>
                <option
                  value="{{ item?.value }}"
                  *ngFor="let item of issue_status_list"
                >
                  {{ item?.label }}
                </option>
              </select>
              <mat-error
                *ngIf="
                  form2.controls['issue_status'].touched &&
                  form2.controls['issue_status'].errors?.required
                "
              >
                {{ "lang_field_required" | language }}
              </mat-error>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="issue_owner">{{
                "lang_issue_owner" | language
              }}</label>
              <input
                type="text"
                class="form-control"
                id="issue_owner"
                name="issue_owner"
                formControlName="issue_owner"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="issue_action_by">{{
                "lang_issue_action_by" | language
              }}</label>
              <input
                type="text"
                class="form-control"
                id="issue_action_by"
                name="issue_action_by"
                formControlName="issue_action_by"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <label for="issue_recommended_action">{{
                "lang_issue_recommended_action" | language
              }}</label>
              <input
                type="text"
                class="form-control"
                id="issue_recommended_action"
                name="issue_recommended_action"
                formControlName="issue_recommended_action"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <mat-label class="d-block">{{
                "lang_start_date" | language
              }}</mat-label>
              <mat-form-field appearance="outline" style="width: 100%">
                <input
                  matInput
                  [matDatepicker]="issue_start_date"
                  placeholder="{{ 'lang_start_date' | language }}"
                  readonly
                  formControlName="issue_start_date"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="issue_start_date"
                ></mat-datepicker-toggle>
                <mat-datepicker #issue_start_date></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <mat-label class="d-block">{{
                "lang_issue_expected_closure_date" | language
              }}</mat-label>
              <mat-form-field appearance="outline" style="width: 100%">
                <input
                  matInput
                  [matDatepicker]="issue_expected_closure_date"
                  placeholder="{{
                    'lang_issue_expected_closure_date' | language
                  }}"
                  readonly
                  formControlName="issue_expected_closure_date"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="issue_expected_closure_date"
                ></mat-datepicker-toggle>
                <mat-datepicker #issue_expected_closure_date></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <div class="form-group">
              <mat-label class="d-block">{{
                "lang_end_date" | language
              }}</mat-label>
              <mat-form-field appearance="outline" style="width: 100%">
                <input
                  matInput
                  [matDatepicker]="issue_end_date"
                  placeholder="{{ 'lang_end_date' | language }}"
                  readonly
                  formControlName="issue_end_date"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="issue_end_date"
                ></mat-datepicker-toggle>
                <mat-datepicker #issue_end_date></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer pad15">
        <div class="row">
          <div class="col-12 mb-10">
            <app-alert id="default-alert"></app-alert>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-xs-12 mb-10">
            <button
              type="button"
              class="btn btn-secondary secondarybutton"
              data-dismiss="modal"
              (click)="modalRef.hide()"
            >
              {{ "lang_close" | language }}
            </button>
          </div>
          <div class="col-md-6 col-xs-12 mb-10">
            <button type="submit" class="albutton">
              {{ "lang_submit" | language }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
